// libraries
import React, { useState, useRef } from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'

// svg
import { GeneralStar, GeneralChat, GeneralStarFull } from '/react4xp/components/Svg/Icons/General'
import { UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

// utils
import { slugify } from '/lib/reactutils/utils.js'

interface MinKavlifavorittUserListPartProps {
    assets: {
        images: {
            base: string
            lights: string
            logosDark: string
            logosLight: string
            mask: string
        }
    }
    likeContentServiceUrl?: string
    minKavliSubmissionPageUrl: string
    minKavlifavoritts: {
        id?: string
        title: string
        author: string
        href: string
        colorLight: boolean
        color: string
        likes: string
        comments: string
        ingredients: {
            name: string
            image: string
        }[]
    }[]
    likedContents?: string[]
    strings: {
        ideasHeader: string
        ideasIntro: string
        ideasMainButton: string
    }
}

export default function MinKavlifavorittUserList({
    strings,
    assets,
    likeContentServiceUrl,
    minKavliSubmissionPageUrl,
    minKavlifavoritts,
    likedContents
}: MinKavlifavorittUserListPartProps) {
    const [contentsLiked, setContentsLiked] = useState(likedContents || [])
    const toggleLike = async (event, minKavlifavoritt) => {
        event.target.disabled = true
        try {
            const response = await fetch(`${likeContentServiceUrl}?contentId=${minKavlifavoritt.id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    isLiked: !contentsLiked?.includes(minKavlifavoritt.id)
                })
            })

            const data = await response.json()

            if (response.ok) {
                minKavlifavoritt.likes = data.totalLikes

                if (data.isLiked) {
                    setContentsLiked([...contentsLiked, minKavlifavoritt.id])
                } else {
                    setContentsLiked(contentsLiked.filter(id => id !== minKavlifavoritt.id))
                }
            }
        } catch (error) {
            console.log('error', error)
        }
        event.target.disabled = false
    }

    return (
        <>
            {(minKavlifavoritts.length > 0) ? (
                <>
                    <Section bgColor='red' className='page-user__ideas'>
                        <div className='container'>

                            <h2 className='h2 white title-top'>
                                {strings.ideasHeader}
                            </h2>

                            <div className='min-kavli-grid'>
                                <div className='min-kavli-grid__wrapper'>

                                    {minKavlifavoritts.map((item, i) => (
                                        <div key={i} className='grid-item bg-white'>
                                            <a href={item.href}>

                                                <div className='image'>

                                                    <img src={assets.images.base} alt='Min Kavlifavoritt' className='base' />
                                                    <img src={assets.images.lights} alt='Min Kavlifavoritt' className='lights' />

                                                    <img
                                                        src={clsx(
                                                            item.colorLight === false ? assets.images.logosDark : assets.images.logosLight
                                                        )}
                                                        alt='Min Kavlifavoritt'
                                                        className='logos'
                                                    />

                                                    <div className='texts'>
                                                        <div className='texts-wrapper'>
                                                            <span>{item.ingredients[0].name}</span> & <span>{item.ingredients[1].name}</span> & <span>{item.ingredients[2].name}</span>
                                                        </div>
                                                    </div>

                                                    <div className='mask' style={{
                                                        maskImage: `url('${assets.images.mask}')`,
                                                        WebkitMaskImage: `url('${assets.images.mask}')`
                                                    }}>

                                                        <div className='color' style={{ backgroundColor: item.color }}></div>

                                                        <div className='ingredient-01'>

                                                            <img
                                                                src={item.ingredients[0].image}
                                                                alt={item.ingredients[0].name}
                                                                className='img'
                                                                data-ingredient={slugify(item.ingredients[0].name)}
                                                            />

                                                        </div>

                                                        <div className='ingredient-02'>

                                                            <img
                                                                src={item.ingredients[1].image}
                                                                alt={item.ingredients[1].name}
                                                                className='img'
                                                                data-ingredient={slugify(item.ingredients[1].name)}
                                                            />

                                                        </div>

                                                        <div className='ingredient-03'>

                                                            <img
                                                                src={item.ingredients[2].image}
                                                                alt={item.ingredients[2].name}
                                                                className='img'
                                                                data-ingredient={slugify(item.ingredients[2].name)}
                                                            />

                                                        </div>

                                                    </div>

                                                </div>

                                                <p className='text-smaller author'>
                                                    {item.author}
                                                </p>

                                                <h3 className='h4 title'>
                                                    {item.title}
                                                </h3>
                                            </a>
                                            <div className='icons text-smaller'>

                                                <button
                                                    onClick={(e) => {
                                                        toggleLike(e, item)
                                                    }}
                                                >
                                                    <span className='icons__item'>
                                                        {contentsLiked?.includes(item.id) ? <GeneralStarFull /> : <GeneralStar variant='outline' />}
                                                        <span>
                                                            {item.likes ? item.likes : '0'}
                                                        </span>
                                                    </span>
                                                </button>

                                                <button
                                                    onClick={(e) => {
                                                        window.open(`${item.href}#user-review-comments`, '_self')
                                                    }}
                                                >
                                                    <span className='icons__item'>
                                                        <GeneralChat variant='outline' />
                                                        <span>
                                                            {item.comments ? item.comments : '0'}
                                                        </span>
                                                    </span>
                                                </button>

                                            </div>
                                            <a href={item.href}>
                                                <div className='arrow'>
                                                    <UxArrowRight />
                                                </div>

                                            </a>
                                        </div>
                                    ))}

                                </div>
                            </div>

                        </div>
                    </Section>
                </>
            ) : (
                <Section bgColor='red' paddingTop='none'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3'>
                                <div className='page-user__content bg-white'>

                                    <h2 className='page-user__title h3'>
                                        {strings.ideasHeader}
                                    </h2>

                                    <div className='page-user__desc negative-margin'
                                        dangerouslySetInnerHTML={{
                                            __html: strings.ideasIntro
                                        }}
                                    />

                                    <Button
                                        href={minKavliSubmissionPageUrl}
                                        color='transparent'
                                        hover='blue'
                                        hasBorders
                                        noUnderline
                                    >
                                        {strings.ideasMainButton}
                                    </Button>

                                </div>
                            </div>
                        </div>
                    </div>
                </Section>
            )}
        </>
    )
}